export const SET_HISTORY_CREATE_SURVEY = 'SET_HISTORY_CREATE_SURVEY';
export const SET_STEP_CREATE_SURVEY = 'SET_STEP_CREATE_SURVEY';
export const CLEAR_CREATE_SURVEY = 'CLEAR_CREATE_SURVEY';
export const SET_OPEN_DOWNLOAD = 'SET_OPEN_DOWNLOAD';
export const SET_OPEN_CREATE_OPTIONS = 'SET_OPEN_CREATE_OPTIONS';
export const SET_OPEN_SCHEDULE = 'SET_OPEN_SCHEDULE';
export const SET_OPEN_CANCEL_SCHEDULE = 'SET_OPEN_CANCEL_SCHEDULE';
